import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AddLimiteProduitComponent } from "./add-limite-produit/add-limite-produit.component";
import { EditLimiteProduitComponent } from "./edit-limite-produit/edit-limite-produit.component";
import { LimiteProduitDTO } from "../core/model/limiteproduit/limite-produit-dto";
import { Produit } from "../core/model/produit";
import { LimiteProduitService } from "../core/service/limite-produit.service";
import { ProduitService } from "../core/service/produit.service";

@Component({
  selector: "app-limite-produit",
  templateUrl: "./limite-produit.component.html",
  styleUrls: ["./limite-produit.component.scss"],
})
export class LimiteProduitComponent implements OnInit {
  produitId: number;
  limites: LimiteProduitDTO[];
  produit: Produit;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _limiteProduitService: LimiteProduitService,
    private _produitService: ProduitService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.produitId = params["produitId"];
      this.getProduitById(this.produitId);
      this.findAllByProduitId(this.produitId);
    });
  }

  findAllByProduitId(produitId) {
    this._limiteProduitService.findAllByProduitId(produitId).subscribe(
      (data) => {
        this.limites = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getProduitById(produitId) {
    this._produitService.getProduitById(produitId).subscribe(
      (data) => {
        this.produit = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  add(): void {
    const modalRef = this.modalService.open(AddLimiteProduitComponent, {
      centered: true,
    });
    // Contexte filtre (pas l'entité éditée)
    modalRef.componentInstance.produitId = this.produitId;

    modalRef.result.then(
      (data) => {
        // on close
        this.findAllByProduitId(this.produitId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  edit(limiteProduit: LimiteProduitDTO): void {
    const modalRef = this.modalService.open(EditLimiteProduitComponent, {
      centered: true,
    });
    modalRef.componentInstance.limiteProduit = limiteProduit;

    modalRef.result.then(
      (updated: LimiteProduitDTO) => {
        if (updated && this.limites) {
          const index = this.limites.findIndex((l) => l.id === updated.id);
          if (index !== -1) {
            this.limites[index] = {
              ...this.limites[index],
              ...updated,
            };
            this.limites = [...this.limites];
            return;
          }
        }
        this.findAllByProduitId(this.produitId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }
}
